import getFormattedPrice from '../property/getFormattedPrice';
import puralise from '../puralise';

const getTotalProperties = (category: string, totalProperties?: number, totalDevelopments?: number) => {
  if (category === 'newhomes' && typeof totalProperties === 'number') {
    return [puralise('development', 'developments', totalDevelopments), getFormattedPrice(totalDevelopments, '')];
  }

  if (typeof totalProperties === 'number') {
    return [puralise('property', 'properties', totalProperties), getFormattedPrice(totalProperties, '')];
  }

  return ['', ''];
};

export default getTotalProperties;
